import { useState } from 'react'
import { Button } from '@radix-ui/themes'
import { CreditCard } from 'lucide-react'

import { customPost } from '@/utils/customFetch'
import { makeUrlTransferPayment } from '@/hooks/connectionData'

interface TransferPaymentButtonProps {
  transferId: string
  initPoint?: string
  disabled?: boolean
}

/**
 * Opens Mercado Pago Checkout Pro in a new tab.
 * If initPoint is provided, it uses it directly.
 * Otherwise, it fetches it from the backend.
 */
export const TransferPaymentButton = ({ transferId, initPoint, disabled = false }: TransferPaymentButtonProps) => {
  const [loading, setLoading] = useState(false)

  const handlePay = async () => {
    if (initPoint) {
      window.open(initPoint, '_blank')

      return
    }

    setLoading(true)
    try {
      const response = await customPost<{ initPoint?: string }>(makeUrlTransferPayment(), {
        transferId,
      })

      if (response && response.initPoint) {
        window.open(response.initPoint, '_blank')
      } else {
        alert('Error al generar link de pago')
      }
    } catch (error: any) {
      alert(error.message || 'Error al comunicarse con Mercado Pago')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button onClick={handlePay} disabled={disabled || loading} size="3" color="blue">
      <CreditCard className="w-4 h-4" />
      {loading ? 'Generando Pago...' : 'Pagar con Mercado Pago'}
    </Button>
  )
}
